import * as React from "react";

import {
  Button,
  Menu,
  MenuTrigger,
  MenuList,
  MenuItem,
  MenuPopover,
} from "@fluentui/react-components";

interface PopupMenuProps {  
  ItemList: {
    name: string;
    link: string;
  }[];
  Icon: React.ReactNode;
}

export const PopupMenu = ({ItemList, Icon}: PopupMenuProps) => {
  const navigateToLocation = (link: string) => window.location.assign('/#' + link);

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="transparent"
          style={{
            position: "absolute",
            right: "0",
          }}
        >
          {Icon}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {ItemList.map((item) => ( 
            <MenuItem 
              key={item.name}
              content={item.name }
              onClick={navigateToLocation.bind(null, item.link)}
            />
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

export default PopupMenu;
